<div class="sub-menu">
  <div class="overlay" (click)="onMenuClosed.emit()">

  </div>
  <div class="sub-menu-inner" style="width:256px" [class.left]="position==='left'" [class.right]="position === 'right'">
    <div class="inner h-100">
      <div class="active-organization organization-item title flex-row start-center gap-8">
        <ui-avatar class="org-avatar"
                   [name]="activeOrganization?.orgName"
                   [color]="activeOrganization?.orgColor"
        ></ui-avatar>
        <div uiTruncateText class="truncated-name">
          {{ activeOrganization?.orgName }}
        </div>

      </div>
      <hr class="hr" style="margin: 12px 8px 12px 8px">

      @if (isSupport$ | async) {
        <div class="tabs-menu flex-row">
          <div
            (click)="setActiveTab(Tab.MyOrganizations)"
            [class.selected]="activeTab() === Tab.MyOrganizations"
          >
            {{ 'SIDEBAR.ORG_MENU.TAB_MY_ORGANIZATIONS' | translate }}
          </div>
          <div
            (click)="setActiveTab(Tab.Support)"
            [class.selected]="activeTab() === Tab.Support"
          >
            {{ 'SIDEBAR.ORG_MENU.TAB_SUPPORT' | translate }}
          </div>
        </div>

        @if (activeTab() === Tab.MyOrganizations) {
          <app-switch-organization-default-search
            [userOrganizations]="userOrganizations"
            (onMenuClosed)="onMenuClosed.emit()"
          ></app-switch-organization-default-search>
        } @else {
          <app-switch-organization-support-search
            (onMenuClosed)="onMenuClosed.emit()"
          ></app-switch-organization-support-search>
        }
      } @else {
        <app-switch-organization-default-search
          [userOrganizations]="userOrganizations"
          (onMenuClosed)="onMenuClosed.emit()"
        ></app-switch-organization-default-search>
      }

      <hr class="hr" style="margin: 0px 8px 8px 8px">
      <div class="button-wrapper" *ngIf="(canCreateOrg$ | async) && activeTab() !== Tab.Support">
        <ui-button [text]="'SIDEBAR.ORG_MENU.CREATE_NEW_ORG'|translate" type="secondary" (click)="createOrganization()">
        </ui-button>
      </div>
    </div>
  </div>
</div>
